import React, { useCallback, useEffect, useState } from "react";
import SafeHTML from "./SafeHTML";
import DefaultImage from "../../img/app/default-Image.webp";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { toScreen } from "../modules/Routing";
import {
  CDN,
  defaultAvatarImage,
  defaultMessagesFilter,
  imageFormat,
  jobImagesFolder,
  serverUrl,
  thumbSuffix,
  userImagesFolder,
} from "../config/GeneralConfig";

import { closeSpinner, modal, showSpinner } from "../modules/Dialogs";
import {
  CalendarIcon,
  AdminIcon,
  CloseIcon,
  CopyIcon,
  CopySuccessIcon,
  MessageIcon,
  StarIcon,
} from "./SvgIcon";
import {  markTransfer } from "../modules/Transfers";
import { toast } from "react-toastify";

const TransfersDetails = ({
  onClose,
  transferDetails,
  theCallBackFunc,
  userDetails,
}) => {
  const [activeTab, setActiveTab] = useState("driverdetails");
  const [copiedJobId, setCopiedJobId] = useState(false);

  const [copiedClientId, setCopiedClientId] = useState(false);
  const [copiedDriverId, setCopiedDriverId] = useState(false);

  const navigate = useNavigate();

 

  const handleJobIdCopy = () => {
    const shortId = transferDetails?.jobDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedJobId(true);
      setTimeout(() => setCopiedJobId(false), 1500);
    }
  };

  const handleClientIdCopy = () => {
    const shortId = transferDetails?.userDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedClientId(true);
      setTimeout(() => setCopiedClientId(false), 1500);
    }
  };

  const handleDriverIdCopy = () => {
    const shortId = transferDetails?.driverDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedDriverId(true);
      setTimeout(() => setCopiedDriverId(false), 1500);
    }
  };

  const handleMarkTransfer = useCallback(
    async ({ jobId, paymentTransfer }) => {
      showSpinner();

      const markTransfer_done = (resStatus, responseString, resJson) => {
        closeSpinner();

        if (resStatus === 200) {
          theCallBackFunc?.();
          onClose?.();
          modal(
            `Job "${transferDetails?.jobDetails?.shortId}" marked as ${paymentTransfer}.`,
            "Good Job!"
          );
        } else if (resStatus === 400) {
          toast.error(resJson?.message || responseString || "Bad Request");
        } else {
          toast.error(
            resJson?.message || responseString || "Something went wrong!"
          );
        }
      };

      const payload = {
        jobId,
        paymentTransfer,
      };

      try {
        markTransfer(payload, markTransfer_done, userDetails?.jwttoken);
      } catch (error) {
        closeSpinner();
        modal("Failed to process refund decision");
      }
    },
    [theCallBackFunc, onClose, userDetails?.jwttoken]
  );

  const getDriverAvatarSrc = useCallback((transferDetails) => {
    if (
      transferDetails?.driverDetails?.avatar &&
      transferDetails?.driverDetails?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${transferDetails?.driverDetails?.shortId}/${transferDetails?.driverDetails?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  const getClientAvatarSrc = useCallback((transferDetails) => {
    if (
      transferDetails?.userDetails?.avatar &&
      transferDetails?.userDetails?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${transferDetails?.userDetails?.shortId}/${transferDetails?.userDetails?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  const getJobDetailsSrc = useCallback((transferDetails, image) => {
    const shortId = transferDetails?.jobDetails?.shortId;
    if (image && shortId) {
      return `${serverUrl}${jobImagesFolder}/${shortId}/${image}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${DefaultImage}${imageFormat}`;
  }, []);

  const originalPrice = transferDetails?.jobDetails?.originalPrice;
  const platformFee = transferDetails?.jobDetails?.platformFee;
  const driverAmount = transferDetails?.jobDetails?.driverAmount;
  const couponCode = transferDetails?.jobDetails?.couponCode;
  const clientPaid = transferDetails?.jobDetails?.bookedFor;
  const feeStructure = transferDetails?.jobDetails?.feeStructure;
  const discountAmount = transferDetails?.jobDetails?.discountAmount;
  return (
    <div className="right-modal reviewTransfer-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2 className="font-semibold">Review Transfer Details</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        <div className="modal-card mb-24">
          <div className="p-24">
            <div className="quote-profile p-0 bg-transparent">
              <div>
                <div className="d-flex align-items-center g-8">
                  <h4 className="mb-0 text-lg text-capitalize">
                    {transferDetails?.jobDetails?.jobType || "-"}
                  </h4>
                  <span
                    className={`text-capitalize badge ms-8 ${
                      transferDetails?.jobDetails?.status === "open"
                        ? "badge-info"
                        : transferDetails?.jobDetails?.status === "closed"
                        ? "badge-danger"
                        : transferDetails?.jobDetails?.status === "paid"
                        ? "badge-warning"
                        : transferDetails?.jobDetails?.status === "complete"
                        ? "badge-success"
                        : ""
                    }`}
                  >
                    {transferDetails?.jobDetails?.status}
                  </span>
                </div>
                <button
                  onClick={handleJobIdCopy}
                  className="badge copyCode-btn mt-4"
                >
                  {transferDetails?.jobDetails?.shortId?.toUpperCase()}

                  {copiedJobId ? <CopySuccessIcon /> : <CopyIcon />}
                </button>
              </div>
              <div className="d-flex align-items-center g-12 ms-auto">
                <button
                  className="btn-outline-light icon-with-btn"
                  onClick={(e) =>
                    toScreen(
                      e,
                      navigate,
                      `/mav/${transferDetails?.driverDetails?.shortId}`
                    )
                  }
                >
                  Details
                </button>
              </div>
            </div>
            {/* Refund Info */}
            <div className="refund-info">
                <div className="refund-info-item">
                <span className="text-sm text-gray-500">Driver Pay</span>
                <span className="fw-bold">
                  £{driverAmount != null ? (driverAmount / 100).toFixed(2) : "0"}
                </span>
              </div>
             
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Platform Fee</span>
                <span className="fw-bold">
                  £{platformFee != null ? (platformFee / 100).toFixed(2) : "0"}
                </span>
              </div>
             <div className="refund-info-item">
                <span className="text-sm text-gray-500">Original Price</span>
                <span className="fw-bold">
                  £{originalPrice != null ? (originalPrice / 100).toFixed(2) : "0"}
                </span>
              </div>
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Client Paid</span>
                <span className="fw-bold">
                  £{clientPaid != null ? (clientPaid / 100).toFixed(2) : "0"}
                </span>
              </div>
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Coupon Code</span>
                <span className="fw-bold">{couponCode || "-"}</span>
              </div>
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Discount Amount</span>
                <span className="fw-bold">
                  £{discountAmount != null ? (discountAmount / 100).toFixed(2) : "0"}
                </span>
              </div>
            </div>
            {feeStructure && (
              <div className="fee-structure-section">
                <span className="text-sm text-gray-500 fw-semibold">Fee Structure</span>
                <table className="fee-structure-table">
                  <thead>
                    <tr>
                      <th>Key</th>
                      <th>Formula</th>
                      <th>Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(feeStructure) ? feeStructure : [feeStructure]).map((fs, i) => (
                      <tr key={i}>
                        <td>{fs?.key || "-"}</td>
                        <td>{fs?.formula || "-"}</td>
                        <td>{fs?.rate != null ? fs.rate : "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className="client-review border-top-0 pt-0">
              <h3 className="text-sm mb-8">Client Review</h3>
              <div className="client-review-item border-gray">
                {[
                  ...Array(transferDetails?.jobDetails?.ratings?.stars || 0),
                ].map((_, index) => (
                  <StarIcon key={index} />
                ))}
                <p className="text-sm review-content">
                  {transferDetails?.jobDetails?.ratings?.comment ||
                    "No Review Found"}
                </p>
                <p className="review-name">
                  {transferDetails?.jobDetails?.ratings?.comment
                    ? `— ${transferDetails?.userDetails?.firstname}`
                    : " "}
                </p>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-card mb-24">
          <div className="custom-tabs m-0">
            <div
              className={`tab-item ${
                activeTab === "driverdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("driverdetails")}
            >
              Driver details
            </div>
            <div
              className={`tab-item ${
                activeTab === "jobdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("jobdetails")}
            >
              Job details
            </div>

            <div
              className={`tab-item ${
                activeTab === "clientdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("clientdetails")}
            >
              Client details
            </div>
          </div>
          {/* Profile Info */}
          {activeTab === "driverdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div className="d-flex align-items-center g-12">
                    {/* <img
                      src={getDriverAvatarSrc(transferDetails)}
                      alt="avatar"
                      className="avatar-pic"
                      onError={(e) => {
                        e.target.src = defaultAvatarImage;
                      }}
                    /> */}
                    <img
                      src={`${CDN}/${transferDetails?.driverDetails?.avatar}`}
                      alt="avatar"
                      className="avatar-pic"
                      onError={(e) => {
                        e.target.src = defaultAvatarImage;
                      }}
                    />
                    <div className="text-capitalize">
                      {`${
                        transferDetails?.driverDetails?.firstname
                          ? transferDetails.driverDetails.firstname
                          : ""
                      } ${
                        transferDetails?.driverDetails?.lastname
                          ? transferDetails.driverDetails.lastname
                          : ""
                      }`}
                      <br />
                      <button
                        onClick={handleDriverIdCopy}
                        className="badge copyCode-btn"
                      >
                        {transferDetails?.driverDetails?.shortId?.toUpperCase()}

                        {copiedDriverId ? <CopySuccessIcon /> : <CopyIcon />}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        "/message/" + transferDetails?.driverDetails?.shortId,
                        false,
                        {
                          receiverId: transferDetails?.driverDetails?._id,
                          receiverShortId:
                            transferDetails?.driverDetails?.shortId,
                          receiverType: "user",
                          userShortId1: "admin",
                          userShortId2:
                            transferDetails?.driverDetails?.shortId,
                          username2:
                            transferDetails?.driverDetails?.accountInfo
                              ?.username,
                          selectedPage:
                            window.history.state?.usr?.selectedPage ?? 1,
                          selectedFilter:
                            window.history.state?.usr?.selectedFilter ??
                            defaultMessagesFilter,
                          previousPath:
                            window.history.state?.usr?.previousPath ??
                            window.location.pathname,
                        }
                      )
                    }
                  >
                    <MessageIcon />
                  </button>
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        `/mav/${transferDetails?.driverDetails?.shortId}`
                      )
                    }
                  >
                    Details
                  </button>
                </div>
              </div>
              <div className="p-24">
                <ul className="profile-info">
                  <li className="profile-info-item">
                    <span className="profile-info-title">Rating</span>
                    <p className="text-capitalize">
                      {transferDetails?.driverDetails?.ratings || "0"}
                    </p>
                  </li>
                  {/* <li className="profile-info-item">
                    <span className="profile-info-title">Joined on</span>
                    <p className="text-capitalize">
                      {transferDetails?.accountInfo?.surname}
                    </p>
                  </li> */}
                  <li className="profile-info-item ">
                    <span className="profile-info-title">Jobs</span>
                    <p className="text-capitalize">
                      {`${
                        (transferDetails?.driverDetails?.completedQuotes ||
                          0) +
                        (transferDetails?.driverDetails?.refundedQuotes || 0)
                      } booked / ${
                        transferDetails?.driverDetails?.cancellationRate || 0
                      } cancelled`}
                    </p>
                  </li>
                  <li className="profile-info-item">
                    <span className="profile-info-title">Quotes</span>
                    <p>{transferDetails?.driverDetails?.quoteCount}</p>
                  </li>
                </ul>
              </div>
            </>
          )}
          {/* Notification List */}
          {activeTab === "jobdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div>
                    <h4 className="mb-0 text-lg text-capitalize">
                      {transferDetails?.jobDetails?.jobType || "-"}
                      <span
                        className={`text-capitalize badge ms-8 ${
                          transferDetails?.jobDetails?.status === "open"
                            ? "badge-info"
                            : transferDetails?.jobDetails?.status === "closed"
                            ? "badge-danger"
                            : transferDetails?.jobDetails?.status === "paid"
                            ? "badge-warning"
                            : transferDetails?.jobDetails?.status ===
                              "complete"
                            ? "badge-success"
                            : ""
                        }`}
                      >
                        {transferDetails?.jobDetails?.status}
                      </span>{" "}
                    </h4>
                    <button
                      onClick={handleJobIdCopy}
                      className="badge copyCode-btn"
                    >
                      {transferDetails?.jobDetails?.shortId?.toUpperCase()}

                      {copiedJobId ? <CopySuccessIcon /> : <CopyIcon />}
                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        `/job/${transferDetails?.jobDetails?.shortId}`
                      )
                    }
                  >
                    Details
                  </button>
                </div>
              </div>
              <div className="job-images p-24 mb-0 pb-0">
                {transferDetails?.jobDetails?.images?.length > 0 &&
                  transferDetails?.jobDetails?.images.map((image, index) => (
                    <div className="job-image" key={index}>
                      <a
                        href={`${CDN}/${transferDetails?.jobDetails?.images[index]}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* <img
                          src={getJobDetailsSrc(transferDetails, image)}
                          alt={`Job image ${index + 1}`}
                          className="c-avatar__pic"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `../img/${DefaultImage}${imageFormat}`;
                          }}
                        /> */}
                        <img
                          src={`${CDN}/${transferDetails?.jobDetails?.images[index]}`}
                          alt={`Job image ${index + 1}`}
                          className="c-avatar__pic"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `../img/${DefaultImage}${imageFormat}`;
                          }}
                        />
                      </a>
                    </div>
                  ))}
              </div>

              <ul className="profile-info p-24">
                <li className="profile-info-item">
                  <span className="profile-info-title">Posted on</span>
                  <p>
                    {" "}
                    {moment(transferDetails?.jobDetails?.creationDate).format(
                      "DD MMM YYYY, HH:mm"
                    ) || "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Quotes received</span>
                  <p>{transferDetails?.jobDetails?.quoteCount || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">From</span>
                  <p>{transferDetails?.jobDetails?.from || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">To</span>
                  <p>{transferDetails?.jobDetails?.to || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Booked on</span>
                  <p>
                    {" "}
                    {transferDetails?.jobDetails?.bookedOn
                      ? moment(transferDetails.jobDetails.bookedOn)
                          ?.tz("Europe/London")?.format("DD MMM YYYY , HH:mm")
                      : "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Completed on</span>
                  <p>
                    {transferDetails?.jobDetails?.mavPaymentDetails
                      ?.transferCompletedOn
                      ? moment(
                          transferDetails.jobDetails.mavPaymentDetails
                            .transferCompletedOn
                        )
                          ?.tz("Europe/London")?.format("DD MMM YYYY , HH:mm")
                      : "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Cancelled On</span>
                  <p>
                    {" "}
                    {transferDetails?.cancellationDetails?.cancelledOn
                      ? moment(transferDetails.cancellationDetails.cancelledOn)
                          ?.tz("Europe/London")?.format("DD MMM YYYY , HH:mm")
                      : "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Scheduled For</span>
                  <p>
                    {" "}
                    {transferDetails?.jobDetails?.scheduledFor
                      ? moment(transferDetails.jobDetails.scheduledFor)
                          ?.utc()
                          ?.format("DD MMM YYYY , HH:mm")
                      : "-"}
                  </p>
                </li>
              </ul>
            </>
          )}

          {/* {Client list} */}
          {activeTab === "clientdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div className="d-flex align-items-center g-12">
                    {/* <img
                      src={getClientAvatarSrc(transferDetails)}
                      alt="Client Avatar"
                      className="avatar-pic"
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = `../img/${defaultAvatarImage}${imageFormat}`;
                      }}
                    /> */}
                    <img
                      src={`${CDN}/${transferDetails?.userDetails?.avatar}`}
                      alt="avatar"
                      className="avatar-pic "
                      onError={(e) => {
                        e.target.src = defaultAvatarImage;
                      }}
                    />
                    <div className="text-capitalize">
                      {`${
                        transferDetails?.userDetails?.firstname
                          ? transferDetails.userDetails.firstname
                          : ""
                      } ${
                        transferDetails?.userDetails?.lastname
                          ? transferDetails.userDetails.lastname
                          : ""
                      }`}
                      <br />
                      <button
                        onClick={handleClientIdCopy}
                        className="badge copyCode-btn"
                      >
                        {transferDetails?.userDetails?.shortId?.toUpperCase()}

                        {copiedClientId ? <CopySuccessIcon /> : <CopyIcon />}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        "/message/" + transferDetails?.userDetails?.shortId,
                        false,
                        {
                          receiverId: transferDetails?.userDetails?._id,
                          receiverShortId:
                            transferDetails?.userDetails?.shortId,
                          receiverType: "user",
                          userShortId1: "admin",
                          userShortId2: transferDetails?.userDetails?.shortId,
                          username2:
                            transferDetails?.userDetails?.accountInfo
                              ?.username,
                          selectedPage:
                            window.history.state?.usr?.selectedPage ?? 1,
                          selectedFilter:
                            window.history.state?.usr?.selectedFilter ??
                            defaultMessagesFilter,
                          previousPath:
                            window.history.state?.usr?.previousPath ??
                            window.location.pathname,
                        }
                      )
                    }
                  >
                    <MessageIcon />
                  </button>
                </div>
              </div>
              <ul className="profile-info p-24">
                <li className="profile-info-item">
                  <span className="profile-info-title">Phone</span>
                  <p>{transferDetails?.userDetails?.telephone || "-"}</p>
                  <div className="client-rating-info"></div>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Email</span>
                  <p className="word-wrap">
                    {transferDetails?.userDetails?.email || "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Jobs</span>
                  <p>{`${
                    transferDetails?.userDetails?.jobCount || "0"
                  } posted, ${
                    transferDetails?.userDetails?.completedJobs || "0"
                  } booked`}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Registered</span>
                  <p>
                    {transferDetails?.userDetails?.registeredOn
                      ? moment(
                          transferDetails?.userDetails?.registeredOn
                        ).format("DD MMM YYYY, HH:mm")
                      : "-"}
                  </p>
                </li>
              </ul>
            </>
          )}
        </div>
        {transferDetails?.jobDetails?.notes?.length > 0 && (
          <div className="modal-card mb-0">
            <div className="px-24 py-20">
              <h3 className="fw-semibold mb-0">Driver profile notes</h3>
            </div>
            <div className="p-24 pt-0">
              {transferDetails?.jobDetails?.notes?.map((note, index) => {
                return (
                  <div className="driver-profile-notes" key={index}>
                    <div className="d-flex align-items-center g-12">
                      <div className="d-flex align-items-center g-4">
                        {note?.createdAt && (
                          <>
                            <CalendarIcon />
                            <span className="text-xs text-gray-600">
                              {moment(note?.createdAt).format(
                                "DD MMM YYYY, HH:mm"
                              )}
                            </span>
                          </>
                        )}
                      </div>
                      <div className="d-flex align-items-center g-4">
                        <AdminIcon />
                        <span className="text-xs text-gray-600">Admin</span>
                      </div>
                    </div>
                    <div className="mt-8 text-sm">
                      <SafeHTML html={note?.content} className="note-content" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {/* Modal Footer */}
      <div className="modal-footer">
        <button className="btn-outline-light" onClick={onClose}>
          Cancel
        </button>
        {transferDetails?.jobDetails?.mavPaymentDetails?.paymentTransfer ===
          "pending" && (
          <button
            className="btn btn-success"
            onClick={() => {
              handleMarkTransfer({
                jobId: transferDetails?.jobDetails?._id,
                paymentTransfer: "complete",
              });
            }}
          >
            Mark as Completed
          </button>
        )}

        {transferDetails?.jobDetails?.mavPaymentDetails?.paymentTransfer ===
          "complete" && (
          <button
            className="btn-warning"
            onClick={() => {
              handleMarkTransfer({
                jobId: transferDetails?.jobDetails?._id,
                paymentTransfer: "pending",
              });
            }}
          >
            Mark as Pending
          </button>
        )}
      </div>
    </div>
  );
};

export default TransfersDetails;
